import React from 'react';
import './SearchSection.scss';
import SearchBoxes from '../../molecules/SearchBoxes/SearchBoxes';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const ImgBg = styled.div`
    background-position: top;

    @media (max-width: 575px) {
        background: linear-gradient(180deg, rgba(255, 255, 255, 0) -23.66%, rgba(9, 9, 9, 0.59) 100%),
        url("${props => props.cdnUrl}media/static/landings/repuestos/header_mobile.jpg?d=576x834"), no-repeat;
        background-size: cover;
        background-position: center top;
    }

    @media (min-width: 576px) and (max-width: 991px) {
        background: linear-gradient(180deg, rgba(255, 255, 255, 0) -23.66%, rgba(9, 9, 9, 0.59) 100%),
        url("${props => props.cdnUrl}media/static/landings/repuestos/header_tablet.jpg?d=900x600"), no-repeat;
        background-size: cover;
        background-position: center top;
    }

    @media (min-width: 992px) {
        background: linear-gradient(180deg, rgba(255, 255, 255, 0) -23.66%, rgba(9, 9, 9, 0.59) 100%),
        url("${props => props.cdnUrl}media/static/landings/repuestos/header_desktop.jpg?d=1920x1280"), no-repeat;
        background-size: cover;
        background-position: center top;
    }
`

function SearchSection({machinerySearch, sparePartsSearch, categoryName, cdnUrl}) {
    const { t } = useTranslation();

      return(
        <ImgBg className="search-section" cdnUrl={cdnUrl}>
            <div className="search-section__container container">
                <h1 className="search-section__header">{t('find_spare_parts')}</h1>
            </div>
            <div className="search-control container">
                <SearchBoxes    machinerySearch={machinerySearch}
                                sparePartsSearch={sparePartsSearch}
                                categoryName={categoryName}/>
            </div>
        </ImgBg>
    );
}

export default SearchSection;